<template>
  <b-container fluid class="d-flex flex-column py-3">
    <b-row class="mb-3">
      <b-col>{{ compareNm }}</b-col>
    </b-row>
    <template v-if="visibleCompare">
      <b-form-row class="mb-2">
        <b-col
          cols="4"
          class="text-center text-truncate"
          v-for="(headerField, index) in headerFields"
          :key="headerField.key"
        >
          <label class="d-block bg-secondary text-light rounded-pill small mb-1">
            {{ headerField.label }}
          </label>
          <span>{{ item[`headerFormatValueNo${index + 1}`] }}</span>
        </b-col>
        <b-col cols="4" class="text-center text-truncate ml-auto">
          <label class="d-block bg-secondary text-light rounded-pill small mb-1">予定/実績</label>
          <span class="text-truncate"
            >{{ item.orderCount }}&nbsp;/&nbsp;{{ item.resultCount }}</span
          >
        </b-col>
      </b-form-row>
      <b-table
        sticky-header
        no-border-collapse
        thead-tr-class="small"
        tbody-tr-class="h5"
        :items="item.details"
        :fields="detailFields"
      >
        <!-- 照合実績 -->
        <template #cell(compareFlg)="data">
          <span v-if="data.item.completeSts === '4'" class="text-success font-weight-bold">RD</span>
          <span v-else-if="data.value === 1" class="text-danger font-weight-bold">NG</span>
          <span v-else-if="data.value === 0" class="text-primary font-weight-bold">OK</span>
          <span v-else>未</span>
        </template>
        <!-- 照合日時 -->
        <template #cell(compareDt)="data">
          <p class="small mb-0">
            {{ data.value ? data.value.split(' ')[0].substring(5).replace('-', '/') : '' }}
          </p>
          <p class="small mb-0">{{ data.value ? data.value.split(' ')[1].substring(0, 5) : '' }}</p>
        </template>
      </b-table>
    </template>
    <b-row v-if="visibleProcButtons">
      <b-col>
        <b-button block variant="primary" class="rounded-pill" @click="onClickProc">{{
          item['completeSts'] === '2' ? 'エラー解除' : '照合継続'
        }}</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { getCompareResultAPI, putCompareResultCancelAPI } from '@/api';
import { getCompareHeaderFields, getCompareDetailToFields, convertItemFormat } from '@/compare';
import { completeSts } from '@/constants';

export default {
  name: 'CompareHistoryDetail',
  data() {
    return {
      compareNm: null, // 読取ルール名
      headerFields: [], // ヘッダ項目リスト
      detailFields: [], // 明細項目リスト
      item: {
        // 照合画面情報
        compareOrderNo: 0, //  照合予定NO
        compareResultNo: 0, //  照合実績NO
        orderCount: 0, //  予定件数
        resultCount: 0, //  実績件数
        details: [] //  明細リスト
      }
    };
  },
  async mounted() {
    // 画面を初期化
    this.$emit('initView', { viewId: this.$options.name, useToolButtons: false });

    const read = this.$store.getters.currentRead;
    if (read) {
      // 読取ルール名取得
      this.compareNm = read.readNm;

      // 照合予定情報取得
      await this.getCompareResult(
        this.$route.params['compareOrderNo'],
        this.$route.params['compareResultNo'],
        this.$store.getters.currentCompare
      );
    }
  },
  computed: {
    /**
     * 照合表示状態
     */
    visibleCompare: function () {
      return this.item['compareOrderNo'];
    },
    /**
     * 処理ボタン表示状態
     */
    visibleProcButtons: function () {
      return (
        this.item['completeSts'] === completeSts.PROCESSING ||
        this.item['completeSts'] === completeSts.COMPLETE_NG
      );
    }
  },
  methods: {
    /**
     * エラー解除ボタン
     */
    onClickProc: async function () {
      // 照合実績エラー解除API
      const ret = await putCompareResultCancelAPI(
        this.item['compareOrderNo'],
        this.item['compareResultNo']
      );
      if (!ret) {
        this.$store.commit('setMessage', '通信エラー(エラー解除)');
        return;
      }

      // 前画面へ
      this.$store.commit('decrementHistoryCount');
      this.$router.back();
    },
    /**
     * 照合実績情報取得
     * @param {number} compareOrderNo 照合予定NO
     * @param {number} compareResultNo 照合実績NO
     * @param {object} compare 照合情報(details:明細付き)
     */
    getCompareResult: async function (compareOrderNo, compareResultNo, compare) {
      // ヘッダ項目セット
      this.headerFields = getCompareHeaderFields(compare);

      // 明細項目セット
      const detailFields = getCompareDetailToFields(compare);
      detailFields.push({ key: 'compareFlg', label: '照合' });
      this.detailFields = detailFields.map(function (x) {
        return { key: x.key, label: x.label, thClass: 'p-1', tdClass: 'px-1' };
      });
      this.detailFields.push({
        key: 'compareDt',
        label: '日時',
        thClass: 'p-1',
        tdClass: 'p-1'
      });

      // 照合実績情報取得API
      const ret = await getCompareResultAPI(compareOrderNo, compareResultNo);
      if (!ret) {
        this.$store.commit('setMessage', '通信エラー(照合実績取得)');
        return;
      }

      this.item = ret.data;
      convertItemFormat(compare, this.item);
    }
  }
};
</script>

<style>
div.container-fluid {
  height: 100%;
}
.b-table-sticky-header {
  height: 100%;
  max-height: none !important;
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
}
</style>
